import { instance, instanceApi } from 'libs';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import * as Types from 'types';
import { PostUserSchedulesUpdateParams, PostUserSchedulesUpdateResponse } from 'types';

export const getUserProfile = (): AxiosPromise<Types.GetUserProfileResponse> => {
  const request: AxiosRequestConfig = {
    url: '/profile',
    method: 'GET',
  };
  return instance(request);
};

export const getUserSites = (
  params: Types.GetUserSitesRequest
): AxiosPromise<Types.GetUserSitesResponse> => {
  const request: AxiosRequestConfig = {
    url: '/user/sites',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getMap = (params: Types.GetMapRequest): AxiosPromise<Types.GetMapResponse> => {
  const request: AxiosRequestConfig = {
    url: '/map/site_status',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const postApproveItems = (
  data: Types.PostApproveRequest
): AxiosPromise<Types.PostApproveResponse> => {
  const request: AxiosRequestConfig = {
    url: '/ky/approve',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

export const postUserSchedulesUpdate = (
  data: PostUserSchedulesUpdateParams
): AxiosPromise<PostUserSchedulesUpdateResponse> => {
  delete data.cooperator_id;
  const request: AxiosRequestConfig = {
    url: '/user/schedule/update',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};
